import type { FC } from 'react';
import { useEffect } from 'react';
import { toast } from 'sonner';
import type { ShortTermComfortBidActivity } from 'src/apis/monolith/types';
import type { ActivitiesRequest } from 'src/apis/monolith/use-activities';
import { useDeleteComfortBid } from 'src/apis/monolith/use-delete-comfort-bid';
import { Button } from 'src/components/buttons-and-actions/button';
import { Modal } from 'src/components/overlay/modal';
import type { Successful } from 'src/hooks/use-axios';
import type { ModalApi } from 'src/hooks/use-modal';

type Props = {
  activity: ShortTermComfortBidActivity;
  activities: Successful<ActivitiesRequest>;
} & ModalApi;

export const DeleteComfortBidModal: FC<Props> = ({
  close,
  closeButton,
  activity,
  activities,
}) => {
  const deleteComfortBid = useDeleteComfortBid();

  useEffect(() => {
    if (!deleteComfortBid.response) return;
    toast.success('Comfort bid was successfully deleted.');
    activities.refresh?.();
    close();
    // oxlint-disable-next-line exhaustive-deps
  }, [deleteComfortBid.response]);

  return (
    <Modal
      title="Delete Comfort Bid"
      onDismiss={close}
      confirmButton={
        <Button
          mode="primary"
          disabled={deleteComfortBid.pending}
          onClick={() => deleteComfortBid.execute(activity.comfortBidId)}
          data-testid="delete-submit"
        >
          {deleteComfortBid.pending ? 'Pending...' : 'Delete Comfort Bid'}
        </Button>
      }
      closeButton={closeButton}
    >
      Please, confirm that you want to delete the Comfort Bid ID{' '}
      {activity.comfortBidId}.
    </Modal>
  );
};
